var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{class:_vm.estilo},[_vm._t("default"),_vm._l((_vm.lista),function(item){return _c('li',{key:item.id,class:_vm.estiloItem,on:{"click":function($event){return _vm.clicar(item)}}},[_vm._t("conteudo",function(){return [_vm._v(" "+_vm._s(item.conteudo)+" ")]},{"item":item})],2)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }